import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Icon zocial-cart"
      xmlns="http://www.w3.org/2000/svg"
      width={35.322}
      height={25.229}
      viewBox="0 0 35.322 25.229"
      {...props}
    >
      <path
        data-name="Icon zocial-cart"
        d="M0 1.451A1.412 1.412 0 01.41.41 1.408 1.408 0 011.451 0h7.411a1.446 1.446 0 01.9.3 1.4 1.4 0 01.52.8l.757 3.091h21.254l.222-.662A1.3 1.3 0 0133.87 2.52a.971.971 0 01.41.063 1.358 1.358 0 01.757.5 1.378 1.378 0 01.284.852 1.762 1.762 0 01-.063.41l-3.721 12.401a1.357 1.357 0 01-.5.757 1.386 1.386 0 01-.852.284H12.552a1.4 1.4 0 01-.9-.314 1.473 1.473 0 01-.52-.789L7.727 2.87H1.451a1.427 1.427 0 01-1.025-.41A1.346 1.346 0 010 1.451zm11.732 5.613l1.955 7.821h15.422l.062-.283 2.272-7.537H11.732zm1.325 15.264a2.767 2.767 0 01.867-2.05 2.848 2.848 0 012.066-.852 2.9 2.9 0 010 5.8 2.847 2.847 0 01-2.066-.851 2.771 2.771 0 01-.867-2.046zm2.05-12.8h5.235v2.9h-4.606zm7.727 2.9l.032-2.9h5.104l-.757 2.9zm1.167 9.9a2.768 2.768 0 01.868-2.05 2.845 2.845 0 012.066-.852 2.9 2.9 0 010 5.8 2.846 2.846 0 01-2.066-.851A2.768 2.768 0 0124 22.329z"
        fill="#ffd200"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
